import { AuthState } from "@/types";

export const API_ENDPOINTS = {
  USERS: {
    REGISTER: "/shared/users/register",
    SETTINGS: '/shared/users/settings',
    PROFILE: '/shared/users/profile',
    RESET_PASSWORD: "/shared/users/reset-password",
    ACCEPT_TERMS: '/shared/users/accept-terms',
    AUTO_REFRESH: '/shared/users/auto-refresh',
    LOCALE: '/shared/users/locale',
  },
  FILTERS: {
    PRESETS: "/shared/filters"
  },
  PAYMENTS: {
    PRICES: '/shared/payments/prices',
    CHECKOUT: '/shared/payments/checkout',
    CHANGE_SUBSCRIPTION: '/shared/payments/change-subscription',
    RESUME_SUBSCRIPTION: '/shared/payments/resume-subscription',
    CANCEL_SUBSCRIPTION: '/shared/payments/cancel-subscription',
    BILLING_PORTAL: '/shared/payments/billing-portal',
    UPGRADE_SUBSCRIPTION: '/shared/payments/upgrade-subscription',
  },
  AH_DATA: {
    UNDERCUT: '/retail/market/ah-data-undercut/',
    DROPSHIP: '/retail/market/ah-data-dropship/',
    HOUSING: '/retail/market/ah-data-housing/',
    REALM_STATS: '/retail/market/realm-stats/',
    INVENTORY_ANALYZE: '/retail/inventory/inventory-analyze/',
  },
  CLASSIC: {
    // POST /classic/market/deals/:region — same-realm undercut deals
    DEALS: '/classic/market/deals/',
  },
  SNIPE: {
    RECENT_HITS: '/shared/users/snipe/recent-hits',
  },
  ADMIN: {
    USER_LOOKUP: '/shared/admin/user-lookup/',
    TOKEN_PREVIEW: '/shared/admin/user-token-preview/',
    ITEM_LOOKUP: '/shared/admin/item-lookup/',
    CHANGE_USER_EMAIL: '/shared/admin/user/',
    SNIPE_AUDIT: '/shared/admin/snipe-audit',
    EMAIL_PREVIEW: '/shared/admin/email-preview/',
  }
} as const;

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_REQUIREMENTS = {
  minLength: PASSWORD_MIN_LENGTH,
  hasUppercase: /[A-Z]/,
  hasLowercase: /[a-z]/,
  hasNumber: /\d/,
  hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/,
} as const;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const initialState: AuthState = {
  isAuthenticated: false,
  isAdmin: false,
  userData: null,
  tokens: null,
  isLoading: false,
};